import React, { Component } from 'react';
import { Col, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import './RecoverPassword.css';
import SimpleErrorList from '../../shared/errors/SimpleErrorList';
import { Link } from 'react-router-dom';
import { authApi } from '../../../services/api/auth-api';

const confirmUrl = window.location.origin + '/reset-password';

class RecoverPassword extends Component {
  constructor() {
    super();
    this.state = {
      confirmationMessage: '',
      email: '',
      errors: [],
      showMessage: false,
    };
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    authApi.recoverPassword(this.state.email, confirmUrl).then((response) => {
      if (response.ok) {
        this.setState({
          confirmationMessage: response.message,
          showMessage: true,
        });
      } else {
        this.setState({
          errors: response.errors,
        });
      }
    });
  };

  render() {
    return (
      <div className="client recover-password">
        <Grid>
          {!this.state.showMessage ? (
            <React.Fragment>
              <Row>
                <Col md={6} mdOffset={3}>
                  <div className="title">
                    <span>Recover your password</span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} mdOffset={3}>
                  <div className="form-container">
                    <form onSubmit={this.handleSubmit}>
                      <Col md={12}>
                        <FormGroup>
                          <FormControl
                            className="input"
                            value={this.state.password}
                            placeholder="Enter your email"
                            type="email"
                            onChange={this.handleEmailChange}
                          />
                        </FormGroup>
                      </Col>

                      {this.state.errors.length > 0 ? (
                        <Col md={12}>
                          <SimpleErrorList errors={this.state.errors} />
                        </Col>
                      ) : null}

                      <Col md={12}>
                        <FormGroup>
                          <input
                            type="submit"
                            className="btn-select btn-orange"
                            value="Next"
                          />
                        </FormGroup>
                      </Col>
                    </form>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Row>
                <Col md={6} mdOffset={3}>
                  <div className="message">
                    <span>{this.state.confirmationMessage}</span>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6} mdOffset={3}>
                  <div className="bottom-title">
                    <Link to="/login">Go to Login</Link>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
        </Grid>
      </div>
    );
  }
}

export default RecoverPassword;



// WEBPACK FOOTER //
// ./src/components/client/recover/RecoverPassword.js